const T_PREFIX = "about-us";

export const bannerTrns = {
  title: `${T_PREFIX}.banner.title`,
  description: `${T_PREFIX}.banner.description`,
  offerButton: `${T_PREFIX}.banner.offer-button`,
};

export const companyMissionTrns = {
  paragraphFirst: `${T_PREFIX}.company-mission.paragraph-first`,
  paragraphSecond: `${T_PREFIX}.company-mission.paragraph-second`,
  paragraphThird: `${T_PREFIX}.company-mission.paragraph-third`,
  paragraphFourth: `${T_PREFIX}.company-mission.paragraph-fourth`,
  paragraphFifth: `${T_PREFIX}.company-mission.paragraph-fifth`,
  paragraphSixth: `${T_PREFIX}.company-mission.paragraph-sixth`,
  paragraphSeventh: `${T_PREFIX}.company-mission.paragraph-seventh`,
};

export const promoBannerTrns = {
  title: `${T_PREFIX}.promo-banner.title`,
  subtitle: `${T_PREFIX}.promo-banner.subtitle`,
  learnMoreButton: `${T_PREFIX}.promo-banner.learn-more-button`,
  signUpNowButton: `${T_PREFIX}.promo-banner.sign-up-now-button`,
};
